import React, { Component } from 'react'
import shortid from "shortid";
import ArticleContainer from '../components/ArticleContainer'
import MyComponent from '../components/MyComponent';

export class TwoColumnFullWidthHeaderPage extends Component {
    render() {
       var state = this.props.state;
        var contentId = state.contentId
        var pagewidth = state.attributes.width
        const stylesObj = {
            width: pagewidth
        };
        return (
            <>
                <div className="containerWarp" wrap-content='HeaderContent' data-cont-id={contentId ? contentId : ""} data-zone="HeaderContent" >
                    <div className="primary-zone" data-zone="HeaderContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="HeaderContent" >
                            <div className="content row gx-0 p-0 justify-content-around mobile-width-style" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="HeaderContent">
                                {state.contents && state.contents.HeaderContent ? state.contents.HeaderContent.map(content => {
                                    let headerContentType = content['@type'];
                                   return (
                                        <MyComponent type={headerContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="HeaderContent" templateName={headerContentType} />
                                    )
                                }
                                ) : ""}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="containerWarp" wrap-content='FullWidthHeaderContent' data-cont-id={contentId ? contentId : ""} data-zone="FullWidthHeaderContent" >
                    <div className="primary-zone" data-zone="FullWidthHeaderContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="FullWidthHeaderContent" >
                            <div className="content row gx-0 justify-content-around mobile-width-style box-shadow-main" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="FullWidthHeaderContent">

                                {state.contents.FullWidthHeaderContent ? (
                                    state.contents.FullWidthHeaderContent.map(content => {
                                        let fullWidthHeaderContentType = content['@type'];
                                        return (
                                            <MyComponent type={fullWidthHeaderContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="FullWidthHeaderContent" templateName={fullWidthHeaderContentType} />
                                        )
                                    })
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                </div>


                <div className="" wrap-content='MainContent' data-cont-id={state.contentId ? state.contentId : ""}>
                    <div className={"containerFullWIdthMargin " + state.attributes.class ? state.attributes.class : ""}>
                        <div className={"row gx-0 footer-inner-nav mobile-width-style box-shadow-main"} style={stylesObj} id={state.attributes.id}>
                            <aside className="containerWarp extra-lg-scrn-section col-lg-3 col-md-0 col-sm-12" data-cont-id={state.contentId ? state.contentId : ""} data-zone="SecondaryContent">
                                <div className="secondary-zone" data-id="zone" data-page-id={state.contentId ? state.contentId : ""} id="secondary-zone" data-zone="SecondaryContent">
                                    {state.contents.SecondaryContent ? (
                                        state.contents.SecondaryContent.map(content => {
                                            let secContentType = content['@type'];
                                            return (
                                                <MyComponent type={secContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="SecondaryContent" templateName={secContentType} />
                                            )
                                        })
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </aside>
                            <section className="containerWarp col-md-12 col-lg-9 col-sm-12" data-cont-id={state.contentId ? state.contentId : ""} data-zone="MainContent" style={{ overflow: "hidden" }}>
                                <div className="primary-zone row g-0 MainContent" data-id="zone" id="primary-zone" data-page-id={state.contentId ? state.contentId : ""} data-zone="MainContent">
                                    {state.contents && state.contents.MainContent.map(content => {
                                        let contentType = content['@type'];
                                        return (
                                            <MyComponent type={contentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="MainContent" templateName={contentType} />
                                        )

                                    })}
                                </div>
                            </section>
                        </div>
                    </div>
                </div>



                <div className="containerWarp" wrap-content='FooterContent' data-cont-id={contentId ? contentId : ""} data-zone="FooterContent" >
                    <div className="primary-zone" data-zone="FooterContent" >
                        <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId ? contentId : ""} id={state.attributes.id} data-id="zone" data-zone="FooterContent" >
                            <div className="content px-0 justify-content-around mobile-width-style box-shadow-footer" style={stylesObj} data-page-id={contentId ? contentId : ""} data-id="zone" data-zone="FooterContent">
                                {/* <NavbarHeader/>                    */}
                                {state.contents && state.contents.FooterContent.map(content => {
                                    let FooterContentType = content['@type'];
                                    return (
                                        <MyComponent type={FooterContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="FooterContent" templateName={FooterContentType} />
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default TwoColumnFullWidthHeaderPage
